import { Box, Heading } from '@wix/design-system';
import {
  StudioCta,
  useAnonymous,
  useIsStudioNewUi,
} from '@wix/package-picker-shared-studio';
import { ArrowDownRight } from '@wix/wix-ui-icons-common/lazy';
import { ArrowDownRight as HarmonyArrowDownRight } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './PageFooter.scss';

export const AnonymousFooterBanner = () => {
  const { signInRedirectionLink } = useAnonymous();
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();
  const ArrowIcon = isStudioNewUi ? HarmonyArrowDownRight : ArrowDownRight;

  const handleAnonymousCtaClick = () => {
    StudioPackagePickerModule.internals.bi.onAnonymousCtaClick?.({
      targetUrl: signInRedirectionLink,
      origin: 'bottom',
    });
    window.open(signInRedirectionLink, '_self');
  };

  return (
    <Box
      direction="vertical"
      height="250px"
      align="center"
      gap="SP5"
      backgroundColor="#06063a" // TODO: use global variable
      verticalAlign="middle"
    >
      <Heading appearance="H1" light>
        {t('studio_package_picker.anon.sendoff.title')}
      </Heading>
      <Box align="center">
        <StudioCta
          filled
          onClick={handleAnonymousCtaClick}
          size="large"
          light
          fullWidth={false}
          suffixIcon={<ArrowIcon className={s.arrowBtnRotate} />}
        >
          {t('studio_package_picker.anon.CTA')}
        </StudioCta>
      </Box>
    </Box>
  );
};
